import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import FullPageSpinner from 'components/common/full-page-spinner';
import { getGrnDetails } from 'services/stock-location/grnServices';
import { useParams } from 'react-router-dom';
import GRNDetailTable from './GRNDetailTable';

export default function GRNsDashboard() {
  const { grnNo } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (grnNo) loadSearch(grnNo);
  }, [grnNo]);

  const loadSearch = grnNo => {
    setIsLoading(true);
    getGrnDetails(grnNo)
      .then(res => {
        if (!res) return;
        setData(res.data ?? []);
      })
      .catch(err => {
        console.error('❌ load Grn error:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="wpo-page">
      <FullPageSpinner show={isLoading} quantity={3} variant="success" />
      <PageHeader
        title={grnNo}
        description="Individual GRN Page"
        className="mb-3"
      />

      <Card>
        <Card.Body>
          <GRNDetailTable data={data} paging={{}} total={data?.length || 0} />
        </Card.Body>
      </Card>
    </div>
  );
}
